import { Loader2 } from 'lucide-react';
import { useApiMessageDetail } from './hooks/useApiMessageDetail';
import { ManageApiMessageForm } from './ManageApiMessageForm';

export const ManageApiMessageFormContainer = ({
  apiMessageId,
  viewOnly = false,
}: {
  apiMessageId: string;
  viewOnly?: boolean;
}) => {
  const { apiMessageDetail, isLoading } = useApiMessageDetail(apiMessageId);

  if (isLoading) {
    return (
      <div className="w-[556px] h-[300px] flex items-center justify-center">
        <Loader2 />
      </div>
    );
  }

  if (!apiMessageDetail) return null;

  return <ManageApiMessageForm apiMessage={apiMessageDetail} viewOnly={viewOnly} />;
};
